module.exports = __webpack_public_path__ + "img/photo-1527525443983-6e60c75fff46.a78d2151.jpeg";